import React from 'react';
import { findMyShareBalance, formatSignedShareMoney } from '../utils/expenseShareUtils';

const SIZE = {
  lg: {
    label: 'text-[11px] font-semibold uppercase tracking-wide',
    amount: 'text-3xl font-black tabular-nums leading-tight',
    settled: 'text-2xl font-black leading-tight',
  },
  md: {
    label: 'text-[10px] font-bold uppercase tracking-wide',
    amount: 'text-xl font-black tabular-nums leading-tight',
    settled: 'text-lg font-black leading-tight',
  },
};

const SharePersonalAmount = ({ balances, userId, currency = 'INR', size = 'lg', align = 'center' }) => {
  const myShare = findMyShareBalance(balances, userId);
  if (userId == null || !Array.isArray(balances) || !balances.length) return null;
  const net = Number(myShare?.net) || 0;
  const styles = SIZE[size] || SIZE.lg;
  const wrap = align === 'right' ? 'text-right flex-shrink-0 min-w-[7.5rem]' : 'text-center';

  if (net > 0.004) {
    return (
      <div className={wrap}>
        <p className={`${styles.label} text-emerald-700 dark:text-emerald-300`}>You are owed</p>
        <p className={`${styles.amount} text-emerald-600 dark:text-emerald-400`}>
          {formatSignedShareMoney(net, currency)}
        </p>
      </div>
    );
  }
  if (net < -0.004) {
    return (
      <div className={wrap}>
        <p className={`${styles.label} text-rose-700 dark:text-rose-300`}>You owe</p>
        <p className={`${styles.amount} text-rose-600 dark:text-rose-400`}>
          {formatSignedShareMoney(net, currency)}
        </p>
      </div>
    );
  }
  return (
    <div className={wrap}>
      <p className={`${styles.label} text-gray-500`}>Your status</p>
      <p className={`${styles.settled} text-gray-500 dark:text-gray-400`}>Settled</p>
    </div>
  );
};

export default SharePersonalAmount;
